import { useCallback } from "react";
import { CustomPropertyKeys } from "../../../infrastructure/const";
import CheckUtils from "../../../utilities/check-utils";

const useVatExempt = () => {
  const isApplied = useCallback((properties: Record<string, any>) => {
    const vatPropertyValue = properties[CustomPropertyKeys.UK.VatExempt];
    let isSelected = false;

    if (!CheckUtils.isNullOrEmptyString(vatPropertyValue)) {
      isSelected = vatPropertyValue.toLowerCase() === "true" ? true : false;
    }

    return isSelected;
  }, []);

  return { isApplied };
};

export default useVatExempt;
